import React from 'react';
import { ICustomizableElement } from '@insurancemenu/imenu-components-lib/dist/types';
import { SubtitleTextStyled, SubtitleWrapperStyled } from './styles';

interface SubtitleWithLinesProps extends ICustomizableElement {
  text: string | JSX.Element;
  narrow?: boolean;
}

const SubtitleWithLines = ({ text, className, narrow = false }: SubtitleWithLinesProps): JSX.Element => {
  return (
    <SubtitleWrapperStyled className={className}>
      {/* Span wrapper helps to show lines from both sides of subtitle */}
      <SubtitleTextStyled $narrow={narrow}>{text}</SubtitleTextStyled>
    </SubtitleWrapperStyled>
  );
};

export default SubtitleWithLines;
